import { Component, OnInit, SimpleChanges } from '@angular/core';
import { SurgeonDTO, SurgeonNotesDTO } from '../Models/Surgeon.model';
import { ProcedureDTO } from '../Models/Procedure.model';
import { DomSanitizer } from '@angular/platform-browser';
import { AppWideUser, Token } from '../Services/AppUserProfile';
import { CookieService } from 'ngx-cookie-service';
import { SrubUpService } from '../Services/ScrubUp.service';
import { SurgeonlistComponent } from '../surgeonlist/surgeonlist.component';
import { Globals } from '../Models/UserProfile.model';
import { ProcedureComponent } from '../procedure/procedure.component';
import { Router } from '@angular/router';
import {environment} from '../../environments/environment';


declare var $: any;
declare var swal: any;
interface FileReaderEventTarget extends EventTarget {
  result: string;
}
interface FileReaderEvent extends Event {
  target: FileReaderEventTarget;
  getMessage(): string;
}

@Component({
  selector: 'app-surgeon-procedures',
  templateUrl: './surgeon-procedures.component.html',
  styleUrls: ['./surgeon-procedures.component.scss'],
  providers: [ProcedureComponent]
})
export class SurgeonProceduresComponent implements OnInit {
  public baseurl: string = environment.base_url;
  showReadOnlyDiv: number;
  showEditingDiv: number;
  iValue: number;
  surgonName:any;
  editvisi: number;
  noteId: string;
  surgeonId: string;
  noteAddedAt: Date;


  public loading = false;
  surgeonObj: SurgeonDTO;
  surgeonNotes: Array<SurgeonNotesDTO>;
  showSurgeonProcedures: boolean;
  surgeonprocedures: Array<ProcedureDTO>;
  getAdminValues: boolean;
  pIndex: number = 0;
  loginUserId: number;
  indexp: number = 1;
  note: string;

  imagePath: string;
  uploadUrl: string;
  imageUploadApiUrlLength: number;
  myHeaders: { [name: string]: any };
  tempUrl: Array<string>;

  constructor(private router: Router, private _sanitizer: DomSanitizer, private surgeon: SurgeonlistComponent, private token: Token, private appUserDetails: AppWideUser, private cookieService: CookieService, private scrubUpService: SrubUpService) {
    if (this.appUserDetails.UserName == undefined && this.token.access_token == undefined || this.appUserDetails.UserName == null && this.token.access_token == null) {
      if (cookieService.check('AppWideUser') && cookieService.check('Token'))
        this.appUserDetails = JSON.parse(this.cookieService.get('AppWideUser'));
      this.token = JSON.parse(this.cookieService.get('Token'));
    }
    this.showReadOnlyDiv = -1;
    this.showEditingDiv = -1;

    this.editvisi = 0;

    this.loginUserId = Globals.LoginUsrId;
    this.getAdminValues = false;
    // this.myHeaders = {
    //   'Authorization': 'Bearer ' + this.token.access_token,
    //   'UserId': this.appUserDetails.UserId,
    //   'ModulePath': "Surgeon List"

    // };
    // this.surgeonNotes = new Array<SurgeonNotesDTO>();
    //  this.surgeonObj = new SurgeonDTO();
    // this.surgeonprocedures = new Array<ProcedureDTO>();
    // this.indexp = 1;

    //  this.surgeonObj = surgeon.surgeonObj;
    //  this.surgeonprocedures = surgeon.surgeonprocedures;

    // this.uploadUrl = this.baseurl + "api/Speciality/UploadImage?userId=" + this.loginUserId;
    // this.imageUploadApiUrlLength = (this.baseurl + "api/Speciality/GetUploadedImage?imageName=").length;
    // this.myHeaders = {
    //   'Authorization': 'Bearer ' + this.token.access_token,
    //   'UserId': this.appUserDetails.UserId,
    //   'ModulePath': "Surgeon Notes"
    // };
    // this.tempUrl = new Array<string>();
   // console.log(this.surgeonprocedures);
  }

  OnUploadFinished(response: any) {
    if (response.serverResponse.response.status == "200") {
      this.imagePath = response.serverResponse.response._body;
      this.imagePath = this.imagePath.substring(1, this.imagePath.length - 1);
    }
  }

  GetImage(imageSrc) {
    imageSrc.forEach(element => {
      this.scrubUpService.GetImage(this.token, element, this.appUserDetails.UserId).subscribe(ab => {
        this.surgeonNotes.forEach(a => {
          if (a.ImagePath == element) {
            a.ImageBase64 = "data:image/png;base64," + ab
          }
        });
      });
    });
  }

  AddNote() {
    let surgeonNote: SurgeonNotesDTO;
    surgeonNote = new SurgeonNotesDTO();
    surgeonNote.NoteId = "";
    surgeonNote.SurgeonId = this.surgeonObj.SurgeonId;
    surgeonNote.Note = this.note;
    surgeonNote.ImagePath = this.imagePath;
    surgeonNote.AddedAt = new Date();

    this.scrubUpService.AddSurgeonNotes(this.token, surgeonNote, this.appUserDetails.UserId).subscribe(x => {
      if (x != undefined) {
        swal({
          title: 'Surgeon Note Added Successfully',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
        this.note = "";
        this.indexp = 1;
        this.getSurgeonNotes();
      }
    })
  }

  getSurgeonNotes() {
    let surgonId= this.cookieService.get("surgonId");
    this.loading = true;
    this.scrubUpService.GetSurgeonNotes(this.token, surgonId).subscribe(x => {
      //console.log(x['Data']);
      if (x['Data'] != null && x['Status'] == true) {
        this.surgeonNotes = x['Data'];
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }

  ToggleFunction() {
    this.note = "";
    if (this.indexp == 1) {
      this.indexp = 2;
      this.showEditingDiv = -1;
    }
    else {
      this.indexp = 1;
    }
  }

  CancelEdit() {
    this.indexp = 1;
    this.showEditingDiv = -1;
  }

  editSurgeonNote(index: number) {
    this.showReadOnlyDiv = -1;
    this.editvisi = 1;

    if (this.showEditingDiv != -1) {
      if (this.iValue == index) {
        this.showEditingDiv = -1;
      }
      else {
        this.showEditingDiv = -1;
        this.showEditingDiv = index;
        this.iValue = index;
      }
      this.noteId = this.surgeonNotes[index].NoteId;
      this.surgeonId = this.surgeonNotes[index].SurgeonId;
      this.note = this.surgeonNotes[index].Note;
      this.imagePath = this.surgeonNotes[index].ImagePath;
      this.noteAddedAt = this.surgeonNotes[index].AddedAt;
      this.indexp = 1;
    }
    else {
      this.noteId = this.surgeonNotes[index].NoteId;
      this.surgeonId = this.surgeonNotes[index].SurgeonId;
      this.note = this.surgeonNotes[index].Note;
      this.imagePath = this.surgeonNotes[index].ImagePath;
      this.noteAddedAt = this.surgeonNotes[index].AddedAt;
      this.showEditingDiv = index;
      this.iValue = index;
      this.indexp = 1;
    }
  }

  UpdateSurgeonNote(index: number) {

    let note: SurgeonNotesDTO;
    note = new SurgeonNotesDTO();
    note.NoteId = this.noteId;
    note.SurgeonId = this.surgeonId;
    note.AddedAt = this.noteAddedAt;
    note.ImagePath = (this.imagePath == this.surgeonNotes[index].ImagePath) ? this.imagePath.slice(this.imageUploadApiUrlLength) : this.imagePath;
    note.Note = this.note;

    this.loading = true;
    this.scrubUpService.UpdateSurgeonNote(this.token, note, this.loginUserId).subscribe(x => {
      if (x == "success") {
        swal({
          title: 'Update Successful',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
        // this.specialityName = "";
        this.CancelEdit();
        this.getSurgeonNotes();
      }
      else {

      }
      this.loading = false;
    });
  }
  DeleteSurgeonNote(index: number) {
    this.noteId = this.surgeonNotes[index].NoteId;
    this.surgeonId = this.surgeonNotes[index].SurgeonId;

    this.loading = true;
    this.scrubUpService.DeleteSurgeonNote(this.token, this.noteId, this.surgeonId, this.loginUserId).subscribe(x => {
      if (x == "success") {
        swal({
          title: 'Note Deleted',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
        // this.specialityName = "";
        this.getSurgeonNotes();
      }
      else {

      }
      this.loading = false;
    });
  }
getsurgonProcedure()
{
  let userspecialityId=0;
  let doctorFlag=this.cookieService.get("doctorFlag");
  if(doctorFlag =="true")
  {
    userspecialityId = JSON.parse(this.cookieService.get("userSpecialityId"));
  }
  let surgonId= this.cookieService.get("surgonId");
  this.surgeonprocedures = [];
  this.scrubUpService.surgonProcedureListBySurgonId(this.token,surgonId).subscribe(x => {
    if (x['Data'] != null && x['Status'] == true) {
      this.surgeonprocedures= x['Data'];
      console.log(this.surgeonprocedures);
    }
    this.loading = false;
  },
    error => {
      this.loading = false;
    })
}

  ngOnInit() {
    this.surgonName= this.cookieService.get("surgonName");
    this.getSurgeonNotes();
    this.getsurgonProcedure();
    // Wizard Initialization
    $('.wizard-card').bootstrapWizard({
      'tabClass': 'nav nav-pills',
      'nextSelector': '.btn-next',
      'previousSelector': '.btn-previous',

      onNext: (tab, navigation, index) => {
        //const $valid = $('.wizard-card form').valid();

        return true;
      },

      onInit: function (tab: any, navigation: any, index: any) {

        // check number of tabs and fill the entire row
        let $total = navigation.find('li').length;
        let $wizard = navigation.closest('.wizard-card');

        let $first_li = navigation.find('li:first-child a').html();
        let $moving_div = $('<div class="moving-tab">' + $first_li + '</div>');
        $('.wizard-card .wizard-navigation').append($moving_div);

        $total = $wizard.find('.nav li').length;
        let $li_width = 100 / $total;

        let total_steps = $wizard.find('.nav li').length;
        let move_distance = $wizard.width() / total_steps;
        let index_temp = index;
        let vertical_level = 0;

        let mobile_device = $(document).width() < 600 && $total > 3;

        if (mobile_device) {
          move_distance = $wizard.width() / 2;
          index_temp = index % 2;
          $li_width = 50;
        }

        $wizard.find('.nav li').css('width', $li_width + '%');

        let step_width = move_distance;
        move_distance = move_distance * index_temp;

        let $current = index + 1;

        if ($current == 1 || (mobile_device == true && (index % 2 == 0))) {
          move_distance -= 8;
        } else if ($current == total_steps || (mobile_device == true && (index % 2 == 1))) {
          move_distance += 8;
        }

        if (mobile_device) {
          let x: any = index / 2;
          vertical_level = parseInt(x);
          vertical_level = vertical_level * 38;
        }

        $wizard.find('.moving-tab').css('width', step_width);
        $('.moving-tab').css({
          'transform': 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
          'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'

        });
        $('.moving-tab').css('transition', 'transform 0s');
      },

      onTabClick: (tab: any, navigation: any, index: any) => {

        // if (this.currentTab === 1 && index == 0) {
        //     if (this.form1Valid) {
        //         //this.currentTab = index;
        //         this.currentTab++;
        //         return true;
        //     }
        // }
        // if (this.currentTab === 2 && index == 1) {
        //     if (this.form2Valid) {
        //         //this.currentTab = index;
        //         this.currentTab++;
        //         return true;
        //     }
        // }
        // if (this.currentTab > 2 && index == 2) {
        //     this.currentTab--;
        //     this.form2Valid = false;
        //     return true;
        // }

        return true;
      },

      onTabShow: (tab: any, navigation: any, index: any) => {
        let $total = navigation.find('li').length;
        let $current = index + 1;
        const $wizard = navigation.closest('.wizard-card');

        // If it's the last tab then hide the last button and show the finish instead
        // if ($current === 2) {
        //    $($wizard).find('.btn-previous').hide();
        //     $($wizard).find('.btn-cancel').show();
        // } else {
        //     $($wizard).find('.btn-previous').show();
        //     $($wizard).find('.btn-cancel').hide();
        // }
        if ($current >= $total) {
          $($wizard).find('.btn-next').hide();
          $($wizard).find('.btn-finish').show();
        }
        else {
          $($wizard).find('.btn-next').show();
          $($wizard).find('.btn-finish').hide();
        }

        const button_text = navigation.find('li:nth-child(' + $current + ') a').html();

        setTimeout(function () {
          $('.moving-tab').text(button_text);
        }, 150);

        const checkbox = $('.footer-checkbox');

        if (index !== 0) {
          $(checkbox).css({
            'opacity': '0',
            'visibility': 'hidden',
            'position': 'absolute'
          });
        } else {
          $(checkbox).css({
            'opacity': '1',
            'visibility': 'visible'
          });
        }
        $total = $wizard.find('.nav li').length;
        let $li_width = 100 / $total;

        let total_steps = $wizard.find('.nav li').length;
        let move_distance = $wizard.width() / total_steps;
        let index_temp = index;
        let vertical_level = 0;

        let mobile_device = $(document).width() < 600 && $total > 3;

        if (mobile_device) {
          move_distance = $wizard.width() / 2;
          index_temp = index % 2;
          $li_width = 50;
        }

        $wizard.find('.nav li').css('width', $li_width + '%');

        let step_width = move_distance;
        move_distance = move_distance * index_temp;

        $current = index + 1;

        if ($current == 1 || (mobile_device == true && (index % 2 == 0))) {
          move_distance -= 8;
        } else if ($current == total_steps || (mobile_device == true && (index % 2 == 1))) {
          move_distance += 8;
        }

        if (mobile_device) {
          let x: any = index / 2;
          vertical_level = parseInt(x);
          vertical_level = vertical_level * 38;
        }

        $wizard.find('.moving-tab').css('width', step_width);
        $('.moving-tab').css({
          'transform': 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
          'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'

        });
      }
    });

    // Prepare the preview for profile picture
    $('#wizard-picture').change(function () {
      const input = $(this);

      if (input[0].files && input[0].files[0]) {
        const reader: any = new FileReader();

        reader.onload = function (e: FileReaderEvent) {
          $('#wizardPicturePreview').attr('src', e.target.result).fadeIn('slow');
        };
        reader.readAsDataURL(input[0].files[0]);
      }
    });

    $('[data-toggle="wizard-checkbox"]').click(function () {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).find('[type="checkbox"]').removeAttr('checked');
      } else {
        $(this).addClass('active');
        $(this).find('[type="checkbox"]').attr('checked', 'true');
      }
    });

    $('.set-full-height').css('height', 'auto');

  }

  ngOnChanges(changes: SimpleChanges) {
    const input = $(this);

    if (input[0].files && input[0].files[0]) {
      const reader: any = new FileReader();

      reader.onload = function (e: FileReaderEvent) {
        $('#wizardPicturePreview').attr('src', e.target.result).fadeIn('slow');
      };
      reader.readAsDataURL(input[0].files[0]);
    }
  }

  ngAfterViewInit() {
    $('.wizard-card').each(function () {

      const $wizard = $(this);
      const index = $wizard.bootstrapWizard('currentIndex');
      let $total = $wizard.find('.nav li').length;
      let $li_width = 100 / $total;

      let total_steps = $wizard.find('.nav li').length;
      let move_distance = $wizard.width() / total_steps;
      let index_temp = index;
      let vertical_level = 0;

      let mobile_device = $(document).width() < 600 && $total > 3;

      if (mobile_device) {
        move_distance = $wizard.width() / 2;
        index_temp = index % 2;
        $li_width = 50;
      }

      $wizard.find('.nav li').css('width', $li_width + '%');

      let step_width = move_distance;
      move_distance = move_distance * index_temp;

      let $current = index + 1;

      if ($current == 1 || (mobile_device == true && (index % 2 == 0))) {
        move_distance -= 8;
      } else if ($current == total_steps || (mobile_device == true && (index % 2 == 1))) {
        move_distance += 8;
      }

      if (mobile_device) {
        let x: any = index / 2;
        vertical_level = parseInt(x);
        vertical_level = vertical_level * 38;
      }

      $wizard.find('.moving-tab').css('width', step_width);
      $('.moving-tab').css({
        'transform': 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
        'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'

      });

      $('.moving-tab').css({
        'transition': 'transform 0s'
      });
    });
  }

  SetProcedureId(specialityId: number, pId: string, categoryId: any,SurgeonProcedureID:any) {
    this.pIndex = 1;
    Globals.PId = pId;
   // Globals.SpecialityId = specialityId;
    Globals.CategoryId = categoryId;
    Globals.LoginUsrId = this.loginUserId;
    this.surgeon.pageIndex = 3;
    this.cookieService.set("checklistType",categoryId);
    this.cookieService.set("SurgeonProcedureID",SurgeonProcedureID);



    // document.getElementById('proccomp').style.visibility="block";
  }

  OnBackButtonClick() {
    this.surgeon.pageIndex = 0;
  }

  OnEditButtonClick() {
    this.surgeon.pageIndex = 7;
    this.surgeon.OnEditBtnClick();
  }

  UserClick(btnCount) {
    this.pIndex == 1
  }

  getEquipChecklistDetails(spId,procedurename) {
    let surgonId= this.cookieService.get("surgonId");
    this.surgeon.getEquipmentDetailBySurgon(spId,surgonId);
  // this.surgeon.getEquipChecklistDetails(spId, procId, index);
    this.surgeon.pageIndex = 4;

  }
}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/surgeon-procedures/surgeon-procedures.component.ts